import { render } from "./Movies.vue?vue&type=template&id=66cebb74&ts=true"
import script from "./Movies.vue?vue&type=script&lang=ts"
export * from "./Movies.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/chronicle/chronicle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__